import { createContext } from '@lit/context';
import { IShopAccess } from '../api/model/login-access-token';

// The shop the user is currently working in. `undefined` until selection has
// happened — pages that need a shop (sales, stock, menu, etc.) gate on this.
export const ActiveShopContext = createContext<IShopAccess | undefined>(
  'active-shop'
);
